/**
 * Retrieves the current user's ID from sessionStorage.
 * @returns {string} The user ID.
 * @throws Will throw an error if the user ID is not found.
 */
export const getCurrentUserId = () => {
    try {
        const userProfile = JSON.parse(sessionStorage.getItem("app_userprofile"));
        if (!userProfile || !userProfile.id) {
            throw new Error("User ID not found");
        }
        return userProfile.id;
    } catch (e) {
        console.error("Error retrieving current user ID:", e);
        throw e;
    }
};

export const getCurrentUserProfile = () => {
    try {
        const userProfile = JSON.parse(sessionStorage.getItem("app_userprofile"));
        if (!userProfile || !userProfile.id) {
            throw new Error("User ID not found");
        }
        return userProfile;
    } catch (e) {
        console.error("Error retrieving current user ID:", e);
        throw e;
    }
};

/**
 * Retrieves the current user's role profile ID from sessionStorage.
 * @returns {string} The role profile ID.
 * @throws Will throw an error if the role profile ID is not found.
 */
export const getUserRoleProfileId = () => {
    try {
        const userProfile = JSON.parse(sessionStorage.getItem("app_role_userprofile"));
        if (!userProfile || !userProfile.id) {
            throw new Error("Role profile ID not found");
        }
        return userProfile.id;
    } catch (e) {
        console.error("Error retrieving user role profile ID:", e);
        throw e;
    }
};

/**
 * Retrieves the current user's role profile UUID from sessionStorage.
 * @returns {string} The role profile UUID.
 * @throws Will throw an error if the role profile UUID is not found.
 */
export const getUserRoleProfileUuid = () => {
    try {
        const userProfile = JSON.parse(sessionStorage.getItem("app_role_userprofile"));
        if (!userProfile || !userProfile.uuid) {
            throw new Error("Role profile UUID not found");
        }
        return userProfile.uuid;
    } catch (e) {
        console.error("Error retrieving user role profile UUID:", e);
        throw e;
    }
};

/**
 * Retrieves the current user's role from sessionStorage.
 * @returns {string} The user role.
 * @throws Will throw an error if the zoneinfo attribute is not found.
 */
export const getCurrentUserRole = () => {
    try {
        const userProfile = JSON.parse(sessionStorage.getItem("keycloak_user_profile"));
        if (!userProfile || !userProfile.zoneinfo) {
            throw new Error("Role not found");
        }
        return `ROLE_${userProfile.zoneinfo?.toUpperCase()}`;
    } catch (e) {
        console.error("Error retrieving current user role:", e);
        throw e;
    }
};

/**
 * Retrieves the current user's role from sessionStorage.
 * @returns {string} The user role.
 * @throws Will throw an error if the zoneinfo attribute is not found.
 */
export const getKeycloakUserValidity = () => {
    try {
        const userProfile = JSON.parse(sessionStorage.getItem("keycloak_user_profile"));
        if (!userProfile) {
            throw new Error("Role not found");
        }
        return userProfile.upn?.toUpperCase() == "Y";
    } catch (e) {
        console.error("Error retrieving current user role:", e);
        throw e;
    }
};
